module.exports = __webpack_public_path__ + "img/2015_bicol.e3ba9bca.jpg";